import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import axios from "axios";
 
/* ===========================
   API INSTANCE
=========================== */
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // https://api.bizzmarkindia.com
  timeout: 20000,
});
 
/* ===========================
   COMPANY CODE
=========================== */
const generateCompanyCode = () => {
  const year = new Date().getFullYear();
  const random = Math.random().toString(36).substring(2, 7).toUpperCase();
  return `CMP-${year}-${random}`;
};
 
const Register = () => {
  const [formData, setFormData] = useState({
    companyName: "",
    companycode: generateCompanyCode(),
    email: "",
    password: "",
    contactNumber: "",
    photoUrl: null,
    role: "",
    address: "",
    city: "",
    state: "",
    country: "",
    description: "",
    termsAgreed: false,
  });
 
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
 
  const handlePhotoChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      photoUrl: e.target.files[0],
    }));
  };
 
  /* ===========================
     SUBMIT HANDLER
  =========================== */
  const handleSubmit = async (e) => {
    e.preventDefault();
 
    try {
      const data = new FormData();
 
      data.append("company_name", formData.companyName);
      data.append("company_code", formData.companycode);
      data.append("email", formData.email);
      data.append("password", formData.password);
      data.append("contact_number", formData.contactNumber);
      data.append("address", formData.address);
      data.append("role", formData.role);
      data.append("description", formData.description);
      data.append("terms_agreed", formData.termsAgreed ? 1 : 0);
      data.append("city", formData.city);
      data.append("state", formData.state);
      data.append("country", formData.country);
      data.append("photoUrl", formData.photoUrl);
 
      const res = await api.post(
        "/api/companies/register",
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
 
      if (res.data?.success) {
        alert("✅ Registration successful. Please login.");
        window.location.href = "/login";
      }
    } catch (err) {
      if (!err.response) {
        alert("❌ Network error. Please try again.");
      } else {
        alert(
          err.response?.data?.message ||
          "❌ Failed to register user"
        );
      }
    }
  };
 
 
  return (
    <div className="container mt-5">
      <div className="main-wrapper login-body">
        <div className="login-wrapper">
          <div
            className="container"
            style={{
              backgroundColor: "white",
              padding: "50px",
              borderRadius: "50px",
            }}
          >
            <h2 className="mb-4 text-center">Register User</h2>
 
            <form onSubmit={handleSubmit}>
              {/* Company Name */}
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">User Name *</label>
                  <input
                    type="text"
                    name="companyName"
                    className="form-control"
                    value={formData.companyName}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
 
              {/* Code + Email + Password */}
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">User Code *</label>
                  <input
                    type="text"
                    name="companycode"
                    className="form-control"
                    value={formData.companycode}
                    readOnly
                  />
                </div>
 
                <div className="col-md-4 mb-3">
                  <label className="form-label">Email *</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
 
                <div className="col-md-4 mb-3">
                  <label className="form-label">Password *</label>
                  <input
                    type="password"
                    name="password"
                    placeholder="Pass must be atleast 6 characters"
                    className="form-control"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
 
              {/* Contact */}
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">Contact Number *</label>
                  <input
                    type="tel"
                    name="contactNumber"
                    className="form-control"
                    value={formData.contactNumber}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
 
              {/* Photo */}
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">User Photo *</label>
                  <input
                    type="file"
                    name="photoUrl"
                    className="form-control"
                    onChange={handlePhotoChange}
                    required
                  />
                </div>
              </div>
 
              {/* Address */}
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Address *</label>
                  <input
                    type="text"
                    name="address"
                    className="form-control"
                    value={formData.address}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
 
              {/* City / State / Country ✅ */}
              <div className="row">
                <div className="col-md-4 mb-3">
                  <label className="form-label">City *</label>
                  <input
                    type="text"
                    name="city"
                    className="form-control"
                    value={formData.city}
                    onChange={handleChange}
                    required
                  />
                </div>
 
                <div className="col-md-4 mb-3">
                  <label className="form-label">State *</label>
                  <input
                    type="text"
                    name="state"
                    className="form-control"
                    value={formData.state}
                    onChange={handleChange}
                    required
                  />
                </div>
 
                <div className="col-md-4 mb-3">
                  <label className="form-label">Country *</label>
                  <input
                    type="text"
                    name="country"
                    className="form-control"
                    value={formData.country}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
 
              {/* Description */}
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Description</label>
                  <textarea
                    name="description"
                    className="form-control"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>
              </div>
 
              {/* Terms */}
              <div className="form-check mb-3">
                <input
                  type="checkbox"
                  name="termsAgreed"
                  className="form-check-input"
                  checked={formData.termsAgreed}
                  onChange={handleChange}
                  required
                />
                <label className="form-check-label">
                  I Agree to Terms & Conditions
                </label>
              </div>
 
              <button type="submit" className="btn btn-primary w-100">
                Submit
              </button>
 
              <div className="text-center fs-5 mt-3">
                Already have an account? <Link to="/login">Login</Link>
              </div>
            </form>
 
          </div>
        </div>
      </div>
    </div>
  );
};
 
export default Register;